import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  cardContainerSx,
  cardContentSectionSx,
  cardContentSx,
  cardLabelSx,
  cardScrollWrapperSx,
} from "./StepCard.sx";

export interface StepCardProps {
  index: number;
  selectedIndex: number;
  timeframe: string;
  scope: string;
  goal: string;
  action: string;
}

const getCardOpacity = (
  index: number,
  selectedIndex: number,
  isMobile: boolean
): number => {
  if (isMobile) return 1;
  if (
    index === selectedIndex ||
    index === selectedIndex + 1 ||
    index === selectedIndex - 1
  ) {
    return 1;
  }
  return 0.4;
};

export const StepCard = ({
  index,
  selectedIndex,
  timeframe,
  scope,
  goal,
  action,
}: StepCardProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), {
    defaultMatches: true,
  });
  const opacity = getCardOpacity(index, selectedIndex, isMobile);

  return (
    <Box
      sx={{ ...cardContainerSx, opacity, transition: "opacity 0.3s ease" }}
      color="primary.contrastText"
    >
      <Typography sx={cardLabelSx}>{timeframe}</Typography>
      <Box sx={cardScrollWrapperSx}>
        <Stack sx={cardContentSx}>
          <Typography color="inherit" fontWeight={700}>
            {scope}
          </Typography>
          <Stack sx={cardContentSectionSx}>
            <Typography color="inherit" fontWeight={600}>
              Goal
            </Typography>
            <Typography color="inherit">{goal}</Typography>
          </Stack>
          <Stack sx={cardContentSectionSx}>
            <Typography color="inherit" fontWeight={600}>
              Action
            </Typography>
            <Typography color="inherit">{action}</Typography>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default StepCard;
